document.addEventListener("DOMContentLoaded", () => {

    const maps = document.querySelectorAll(".hgp-fragrance-map");

    const loader = document.getElementById("hgpCartLoader");

    const loaderTitle = loader?.querySelector(
        ".hgp-cart-loader-title"
    );

    const loaderText = loader?.querySelector(
        ".hgp-cart-loader-text"
    );


    /* ==========================================
   SHOW LOADER
========================================== */

    function showCartLoader() {

        if (!loader) return;


        loader.classList.remove(
            "success"
        );


        if (loaderTitle) {

            loaderTitle.textContent =
                "Loading";

        }


        if (loaderText) {

            loaderText.textContent =
                "Adding to cart...";

        }


        loader.classList.add(
            "active"
        );


        loader.setAttribute(
            "aria-hidden",
            "false"
        );


        document.body.style.overflow =
            "hidden";

    }


    /* ==========================================
       SHOW SUCCESS
    ========================================== */

    function showCartSuccess() {

        if (!loader) return;


        loader.classList.add(
            "success"
        );


        if (loaderTitle) {

            loaderTitle.textContent =
                "Added to Cart";

        }


        if (loaderText) {

            loaderText.textContent =
                "Your item is now in your cart.";

        }

    }


    /* ==========================================
       HIDE LOADER
    ========================================== */

    function hideCartLoader() {

        if (!loader) return;


        loader.classList.remove(
            "active",
            "success"
        );


        loader.setAttribute(
            "aria-hidden",
            "true"
        );


        document.body.style.overflow =
            "";

    }


    /* ==========================================
       UPDATE HEADER CART
    ========================================== */

    async function updateHeaderCart() {

        try {

            const response =
                await fetch(
                    "/cart.js",
                    {
                        headers: {
                            "Accept":
                                "application/json"
                        }
                    }
                );


            if (!response.ok) {

                throw new Error(
                    "Unable to fetch cart."
                );

            }


            const cart =
                await response.json();


            const cartCount =
                document.querySelector(
                    "[data-cart-count]"
                );


            if (cartCount) {

                cartCount.textContent =
                    cart.item_count;


                cartCount.classList.toggle(
                    "is-empty",
                    cart.item_count === 0
                );


                cartCount.classList.remove(
                    "cart-count-pop"
                );


                void cartCount.offsetWidth;


                cartCount.classList.add(
                    "cart-count-pop"
                );

            }


            return cart;

        }

        catch (error) {

            console.error(
                "Cart update error:",
                error
            );


            return null;

        }

    }


    /* ==========================================
       PREMIUM CART CELEBRATION
    ========================================== */

    function celebrateCart() {

        const cartButton =
            document.querySelector(
                ".hgp-cart-icon-btn"
            );


        if (!cartButton) return;


        cartButton.classList.remove(
            "cart-celebrate"
        );


        void cartButton.offsetWidth;


        cartButton.classList.add(
            "cart-celebrate"
        );


        setTimeout(() => {

            cartButton.classList.remove(
                "cart-celebrate"
            );

        }, 4000);

    }


    /* ==========================================
       AJAX ADD TO CART
    ========================================== */

    document.querySelectorAll(".hgp-fragrance-cart")
        .forEach((button) => {

            button.addEventListener(
                "click",
                async (event) => {

                    event.preventDefault();
                    event.stopPropagation();


                    const variantId =
                        button.dataset.variant;


                    if (!variantId) return;


                    button.disabled = true;


                    showCartLoader();


                    try {

                        const response =
                            await fetch(
                                "/cart/add.js",
                                {
                                    method:
                                        "POST",

                                    headers: {
                                        "Content-Type":
                                            "application/json",

                                        "Accept":
                                            "application/json"
                                    },

                                    body:
                                        JSON.stringify(
                                            {
                                                id:
                                                    Number(
                                                        variantId
                                                    ),

                                                quantity:
                                                    1
                                            }
                                        )
                                }
                            );


                        if (!response.ok) {

                            const errorData =
                                await response.json();


                            throw new Error(
                                errorData.description ||
                                "Unable to add product."
                            );

                        }


                        await response.json();


                        /* Update header count */

                        await updateHeaderCart();


                        /* Change loader to success */

                        showCartSuccess();


                        /* Start cart sparkle animation */

                        celebrateCart();


                        /* Tell Shopify/theme listeners */

                        document.dispatchEvent(
                            new CustomEvent(
                                "cart:refresh"
                            )
                        );


                        document.dispatchEvent(
                            new CustomEvent(
                                "cart:updated"
                            )
                        );


                        /* Keep success visible briefly */

                        setTimeout(() => {

                            hideCartLoader();

                        }, 1000);

                    }

                    catch (error) {

                        console.error(
                            error
                        );


                        if (loaderTitle) {

                            loaderTitle.textContent =
                                "Something went wrong";

                        }


                        if (loaderText) {

                            loaderText.textContent =
                                error.message ||
                                "Please try again.";

                        }


                        setTimeout(() => {

                            hideCartLoader();

                        }, 1800);

                    }

                    finally {

                        button.disabled =
                            false;

                    }

                }
            );

        });

    if (!maps.length) return;


    maps.forEach((map) => {

        const section = map.closest(".hgp-fragrance");

        const center = map.querySelector(
            ".hgp-fragrance-center"
        );

        const bubbles = [
            ...map.querySelectorAll(
                ".hgp-fragrance-bubble"
            )
        ];

        const svg = map.querySelector(
            ".hgp-fragrance-lines"
        );

        const productsArea = section.querySelector(
            ".hgp-fragrance-products"
        );

        const panels = section.querySelectorAll(
            ".hgp-fragrance-product-panel"
        );


        if (!center || !bubbles.length) return;


        let activeBubble = null;

        let draggingBubble = null;

        let pointerOffsetX = 0;

        let pointerOffsetY = 0;

        let originalLeft = 0;

        let originalTop = 0;

        let shuffleInterval = null;

        let isShuffling = false;




        /* ==========================================
   RESPONSIVE POSITION CONFIG
========================================== */

        function getResponsiveConfig() {

            const width = window.innerWidth;


            /* MOBILE */

            if (width < 768) {

                return {

                    mapPadding: 6,

                    centerGap: 8,

                    bubbleGap: 6,

                    maxAttempts: 250,

                    shuffleTime: 5200

                };

            }


            /* TABLET */

            if (width <= 1080) {

                return {

                    mapPadding: 8,

                    centerGap: 12,

                    bubbleGap: 8,

                    maxAttempts: 220,

                    shuffleTime: 5000

                };

            }


            /* HORIZONTAL TABLET */

            if (width < 1280) {

                return {

                    mapPadding: 9,

                    centerGap: 18,

                    bubbleGap: 10,

                    maxAttempts: 180,

                    shuffleTime: 4700

                };

            }


            /* DESKTOP */

            return {

                mapPadding: 10,

                centerGap: 25,

                bubbleGap: 15,

                maxAttempts: 100,

                shuffleTime: 4500

            };

        }


        /* ==========================================
           DRAW CONNECTION LINES
        ========================================== */

        function drawLines() {

            if (!svg) return;

            svg.innerHTML = "";


            const mapRect =
                map.getBoundingClientRect();

            const centerRect =
                center.getBoundingClientRect();


            const centerX =
                centerRect.left -
                mapRect.left +
                centerRect.width / 2;


            const centerY =
                centerRect.top -
                mapRect.top +
                centerRect.height / 2;


            bubbles.forEach((bubble) => {

                if (
                    bubble === activeBubble ||
                    bubble.classList.contains(
                        "is-selected"
                    )
                ) {

                    return;

                }


                const bubbleRect =
                    bubble.getBoundingClientRect();


                const bubbleX =
                    bubbleRect.left -
                    mapRect.left +
                    bubbleRect.width / 2;


                const bubbleY =
                    bubbleRect.top -
                    mapRect.top +
                    bubbleRect.height / 2;


                const line =
                    document.createElementNS(

                        "http://www.w3.org/2000/svg",

                        "line"

                    );


                line.setAttribute(
                    "x1",
                    centerX
                );

                line.setAttribute(
                    "y1",
                    centerY
                );

                line.setAttribute(
                    "x2",
                    bubbleX
                );

                line.setAttribute(
                    "y2",
                    bubbleY
                );


                svg.appendChild(line);

            });

        }


        /* ==========================================
           CHECK IF POSITION HITS CENTER
        ========================================== */

        function overlapsCenter(
            left,
            top,
            bubbleWidth,
            bubbleHeight
        ) {

            const config =
                getResponsiveConfig();


            const centerX =
                map.clientWidth / 2;


            const centerY =
                map.clientHeight / 2;


            const bubbleX =
                left +
                bubbleWidth / 2;


            const bubbleY =
                top +
                bubbleHeight / 2;


            const distance =
                Math.hypot(

                    bubbleX - centerX,

                    bubbleY - centerY

                );


            const safeDistance =

                center.offsetWidth / 2 +

                bubbleWidth / 2 +

                config.centerGap;


            return distance < safeDistance;

        }


        /* ==========================================
           CHECK BUBBLE OVERLAP
        ========================================== */

        function overlapsPosition(
            left,
            top,
            width,
            height,
            positions
        ) {

            const config =
                getResponsiveConfig();


            const padding =
                config.bubbleGap;


            return positions.some(
                (position) => {

                    return !(

                        left +
                        width +
                        padding <
                        position.left

                        ||

                        left >
                        position.left +
                        position.width +
                        padding

                        ||

                        top +
                        height +
                        padding <
                        position.top

                        ||

                        top >
                        position.top +
                        position.height +
                        padding

                    );

                }
            );

        }


        /* ==========================================
           GENERATE SAFE RANDOM POSITION
        ========================================== */

        function getRandomPosition(
            bubble,
            usedPositions
        ) {

            const config =
                getResponsiveConfig();


            const bubbleWidth =
                bubble.offsetWidth;


            const bubbleHeight =
                bubble.offsetHeight;


            const padding =
                config.mapPadding;


            const maxLeft =

                Math.max(

                    padding,

                    map.clientWidth -
                    bubbleWidth -
                    padding

                );


            const maxTop =

                Math.max(

                    padding,

                    map.clientHeight -
                    bubbleHeight -
                    padding

                );


            let left =
                padding;


            let top =
                padding;


            let bestPosition = null;


            /*
             * First try to find a completely
             * collision-free position.
            */

            for (
                let attempt = 0;

                attempt < config.maxAttempts;

                attempt++
            ) {

                left =

                    padding +

                    Math.random() *

                    Math.max(

                        0,

                        maxLeft -
                        padding

                    );


                top =

                    padding +

                    Math.random() *

                    Math.max(

                        0,

                        maxTop -
                        padding

                    );


                const hitsCenter =

                    overlapsCenter(

                        left,

                        top,

                        bubbleWidth,

                        bubbleHeight

                    );


                const hitsBubble =

                    overlapsPosition(

                        left,

                        top,

                        bubbleWidth,

                        bubbleHeight,

                        usedPositions

                    );


                if (
                    !hitsCenter &&
                    !hitsBubble
                ) {

                    return {

                        left,

                        top,

                        width: bubbleWidth,

                        height: bubbleHeight

                    };

                }


                /*
                 * Keep a fallback position that
                 * at least does not hit the center.
                */

                if (
                    !hitsCenter &&
                    !bestPosition
                ) {

                    bestPosition = {

                        left,

                        top,

                        width: bubbleWidth,

                        height: bubbleHeight

                    };

                }

            }


            /*
             * If the screen is very small and there
             * are too many bubbles, use the safest
             * available fallback.
            */

            if (bestPosition) {

                return bestPosition;

            }


            return {

                left:

                    Math.max(

                        padding,

                        Math.min(

                            left,

                            maxLeft

                        )

                    ),

                top:

                    Math.max(

                        padding,

                        Math.min(

                            top,

                            maxTop

                        )

                    ),

                width:
                    bubbleWidth,

                height:
                    bubbleHeight

            };

        }


        /* ==========================================
           RANDOMIZE ALL BUBBLES
        ========================================== */

        function randomizeBubbles(
            instant = false
        ) {

            if (
                draggingBubble ||
                isShuffling
            ) {

                return;

            }


            isShuffling = true;


            const usedPositions = [];


            bubbles.forEach((bubble) => {

                if (
                    bubble === activeBubble ||
                    bubble.classList.contains(
                        "is-selected"
                    )
                ) {

                    return;

                }


                const position =
                    getRandomPosition(

                        bubble,

                        usedPositions

                    );


                usedPositions.push(
                    position
                );


                if (instant) {

                    bubble.style.transition =
                        "none";

                }


                bubble.style.left =
                    `${position.left}px`;

                bubble.style.top =
                    `${position.top}px`;

                bubble.style.right =
                    "auto";

                bubble.style.bottom =
                    "auto";


                bubble.dataset.originalLeft =
                    position.left;

                bubble.dataset.originalTop =
                    position.top;

            });


            if (instant) {

                requestAnimationFrame(() => {

                    bubbles.forEach(
                        (bubble) => {

                            bubble.style.transition =
                                "";

                        }
                    );

                });

            }


            setTimeout(() => {

                drawLines();

                isShuffling = false;

            }, instant ? 50 : 2250);

        }


        /* ==========================================
           ANIMATE LINES DURING BUBBLE MOVEMENT
        ========================================== */

        function animateLinesDuringShuffle() {

            let startTime = null;

            const duration = 2300;


            function animate(time) {

                if (!startTime) {

                    startTime = time;

                }


                drawLines();


                if (
                    time - startTime <
                    duration
                ) {

                    requestAnimationFrame(
                        animate
                    );

                }

            }


            requestAnimationFrame(
                animate
            );

        }


        /* ==========================================
           AUTOMATIC POSITION SHUFFLE
        ========================================== */

        function startAutoShuffle() {

            clearInterval(
                shuffleInterval
            );


            const config =
                getResponsiveConfig();


            shuffleInterval =
                setInterval(() => {

                    if (
                        draggingBubble ||
                        document.hidden
                    ) {

                        return;

                    }


                    randomizeBubbles();

                    animateLinesDuringShuffle();

                }, config.shuffleTime);

        }


        /* ==========================================
           CENTER COLLISION
        ========================================== */

        function isInsideCenter(bubble) {

            const bubbleRect =
                bubble.getBoundingClientRect();

            const centerRect =
                center.getBoundingClientRect();


            const bubbleX =
                bubbleRect.left +
                bubbleRect.width / 2;


            const bubbleY =
                bubbleRect.top +
                bubbleRect.height / 2;


            const centerX =
                centerRect.left +
                centerRect.width / 2;


            const centerY =
                centerRect.top +
                centerRect.height / 2;


            const distance =
                Math.sqrt(

                    Math.pow(
                        bubbleX - centerX,
                        2
                    ) +

                    Math.pow(
                        bubbleY - centerY,
                        2
                    )

                );


            return (
                distance <
                centerRect.width / 2
            );

        }


        /* ==========================================
           SHOW PRODUCTS
        ========================================== */

        function showProducts(
            collectionId
        ) {

            panels.forEach((panel) => {

                panel.classList.remove(
                    "active"
                );

            });


            const activePanel =
                section.querySelector(

                    `.hgp-fragrance-product-panel[data-product-panel="${collectionId}"]`

                );


            if (!activePanel) return;


            if (productsArea) {

                productsArea.classList.add(
                    "has-selection"
                );

            }


            activePanel.classList.add(
                "active"
            );

        }


        /* ==========================================
           RESET ACTIVE BUBBLE
        ========================================== */

        function resetActiveBubble() {

            if (!activeBubble) return;


            activeBubble.classList.remove(
                "is-selected"
            );


            activeBubble = null;

        }


        /* ==========================================
           SELECT BUBBLE
        ========================================== */

        function selectBubble(bubble) {

            if (
                activeBubble &&
                activeBubble !== bubble
            ) {

                resetActiveBubble();

            }


            activeBubble = bubble;


            const collectionId =
                bubble.dataset.fragranceId;


            const title =
                bubble.dataset.fragranceTitle;


            const imageElement =
                bubble.querySelector(

                    ".hgp-fragrance-bubble-image img"

                );


            const image =
                imageElement
                    ? imageElement.src
                    : "";


            center.innerHTML = `

                    <div class="hgp-selected-fragrance">

                    ${image
                    ? `
                    <img
                        class="hgp-selected-fragrance-image"
                        src="${image}"
                        alt="${title || ""}"
                    >
                `
                    : ""
                }

        <div class="hgp-selected-fragrance-overlay"></div>

        <div class="hgp-selected-fragrance-content">

            <span class="hgp-selected-fragrance-label">
                Selected Fragrance
            </span>

            <strong class="hgp-selected-fragrance-title">
                ${title || ""}
            </strong>

        </div>

    </div>

`;


            bubble.classList.add(
                "is-selected"
            );


            showProducts(
                collectionId
            );


            center.classList.remove(
                "drag-over"
            );


            setTimeout(() => {

                randomizeBubbles();

                drawLines();

            }, 100);

        }


        /* ==========================================
           DRAG EVENTS
        ========================================== */

        bubbles.forEach((bubble) => {

            bubble.addEventListener(
                "pointerdown",
                (event) => {

                    if (
                        bubble.classList.contains(
                            "is-selected"
                        )
                    ) {

                        return;

                    }


                    event.preventDefault();


                    draggingBubble = bubble;


                    const bubbleRect =
                        bubble.getBoundingClientRect();


                    pointerOffsetX =
                        event.clientX -
                        bubbleRect.left;


                    pointerOffsetY =
                        event.clientY -
                        bubbleRect.top;


                    originalLeft =
                        parseFloat(
                            bubble.style.left
                        );


                    originalTop =
                        parseFloat(
                            bubble.style.top
                        );


                    bubble.classList.add(
                        "dragging"
                    );


                    bubble.setPointerCapture(
                        event.pointerId
                    );

                }
            );


            bubble.addEventListener(
                "pointermove",
                (event) => {

                    if (
                        draggingBubble !== bubble
                    ) {

                        return;

                    }


                    const mapRect =
                        map.getBoundingClientRect();


                    let left =
                        event.clientX -
                        mapRect.left -
                        pointerOffsetX;


                    let top =
                        event.clientY -
                        mapRect.top -
                        pointerOffsetY;


                    left = Math.max(

                        0,

                        Math.min(

                            left,

                            map.clientWidth -
                            bubble.offsetWidth

                        )

                    );


                    top = Math.max(

                        0,

                        Math.min(

                            top,

                            map.clientHeight -
                            bubble.offsetHeight

                        )

                    );


                    bubble.style.left =
                        `${left}px`;

                    bubble.style.top =
                        `${top}px`;


                    if (
                        isInsideCenter(
                            bubble
                        )
                    ) {

                        center.classList.add(
                            "drag-over"
                        );

                    } else {

                        center.classList.remove(
                            "drag-over"
                        );

                    }


                    drawLines();

                }
            );


            function endDrag(event) {

                if (
                    draggingBubble !== bubble
                ) {

                    return;

                }


                const droppedInside =
                    isInsideCenter(
                        bubble
                    );


                bubble.classList.remove(
                    "dragging"
                );


                center.classList.remove(
                    "drag-over"
                );


                if (droppedInside) {

                    selectBubble(
                        bubble
                    );

                } else {

                    bubble.style.left =
                        `${originalLeft}px`;

                    bubble.style.top =
                        `${originalTop}px`;


                    animateLinesDuringShuffle();

                }


                if (
                    bubble.hasPointerCapture(
                        event.pointerId
                    )
                ) {

                    bubble.releasePointerCapture(
                        event.pointerId
                    );

                }


                draggingBubble = null;

            }


            bubble.addEventListener(
                "pointerup",
                endDrag
            );


            bubble.addEventListener(
                "pointercancel",
                endDrag
            );

        });


        /* ==========================================
           INITIALIZE
        ========================================== */

        requestAnimationFrame(() => {

            randomizeBubbles(true);

            drawLines();

            startAutoShuffle();

        });


        /* ==========================================
           RESIZE
        ========================================== */

        let resizeTimer;

        let previousBreakpoint =
            getResponsiveBreakpoint();


        function getResponsiveBreakpoint() {

            const width =
                window.innerWidth;


            if (width < 768) {

                return "mobile";

            }


            if (width <= 1080) {

                return "tablet";

            }


            if (width < 1280) {

                return "horizontal-tablet";

            }


            return "desktop";

        }


        window.addEventListener(
            "resize",
            () => {

                clearTimeout(
                    resizeTimer
                );


                resizeTimer =
                    setTimeout(() => {

                        const currentBreakpoint =
                            getResponsiveBreakpoint();


                        /*
                         * Recalculate positions using
                         * the CURRENT map dimensions.
                        */

                        randomizeBubbles(
                            true
                        );


                        drawLines();


                        /*
                         * Restart shuffle timing only
                         * when crossing a breakpoint.
                        */

                        if (
                            currentBreakpoint !==
                            previousBreakpoint
                        ) {

                            previousBreakpoint =
                                currentBreakpoint;


                            startAutoShuffle();

                        }

                    }, 200);

            }
        );




        window.addEventListener(
            "orientationchange",
            () => {

                setTimeout(() => {

                    randomizeBubbles(
                        true
                    );


                    drawLines();


                    startAutoShuffle();

                }, 350);

            }
        );

    });

});